import { render } from "./Ocean.vue?vue&type=template&id=4b6a1a0a"
import script from "./Ocean.vue?vue&type=script&lang=js"
export * from "./Ocean.vue?vue&type=script&lang=js"

import "./Ocean.vue?vue&type=style&index=0&id=4b6a1a0a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__